import { FC, ReactElement } from 'react';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import {
  common,
  custom2,
  error,
  grey,
  normalText,
  other,
} from 'assets/colors/colors';

type Variant = 'primary' | 'error' | 'light';

interface ITooltip extends TooltipProps {
  children: ReactElement;
  variant?: Variant;
  boxShadow?: boolean;
  maxWidth?: string;
}

const variantTextColor: Record<Variant, string> = {
  primary: common.white,
  error: error.main,
  light: normalText.main,
};

const variantBackgroundColor: Record<Variant, string> = {
  primary: grey.g700,
  error: custom2.main,
  light: common.white,
};

export const Tooltip: FC<ITooltip> = ({
  children,
  arrow,
  title,
  variant = 'primary',
  boxShadow = false,
  maxWidth = '300px',
  ...rest
}) => (
  <MuiTooltip
    title={title}
    arrow={arrow}
    componentsProps={{
      tooltip: {
        sx: {
          color: variantTextColor[variant],
          background: variantBackgroundColor[variant],
          boxShadow: boxShadow
            ? `8px 8px 8px 8px ${other.customBoxShadow}`
            : 'none',
          maxWidth,
        },
      },
      arrow: {
        sx: {
          color: variantBackgroundColor[variant],
        },
      },
    }}
    {...rest}
  >
    {children}
  </MuiTooltip>
);
